import React, { useContext } from "react";

//Material UI
import Grid from "@material-ui/core/Grid";
import AttachmentIcon from "@material-ui/icons/Attachment";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import CheckIcon from "@material-ui/icons/Check";
import Badge from "@material-ui/core/Badge";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";

//External
import _ from "lodash";

//Internal
import Language from "sccLanguage";
import Message from "sccMessage";
import Device from "sccDevice";
import User from "sccUser";
import Clock from "sccClock";
import CustomCheckbox from "@Components/CustomCheckbox";
import { ModuleWrapperContext } from "@Components/ModuleWrapper/ModuleWrapperContext";
import { moduleMessage } from "@Styles/ModuleMessage";

function Sent(props) {
  const [mwState] = useContext(ModuleWrapperContext);
  const filteredModuleData = mwState.filteredModuleData;
  const handleClick = props.handleClick;
  const handleSingleCheckbox = props.handleSingleCheckbox;
  const resetSorting = props.resetSorting;

  function getPendingMsg(pending) {
    var pendingNo = [];
    _.forEach(pending, function (value, key) {
      if (value.message_status === "pending") {
        pendingNo.push(parseInt(key));
      }
    });
    return pendingNo.length;
  }
  function getFailedMsg(pending) {
    var failedNo = [];
    _.forEach(pending, function (value, key) {
      if (value.message_status === "fail") {
        failedNo.push(parseInt(key));
      }
    });
    return failedNo.length;
  }
  function showStatus(data) {
    if (
      getPendingMsg(data.recipients.device_message_status) === 0 &&
      getFailedMsg(data.recipients.device_message_status) === 0
    ) {
      return <CheckIcon />;
    } else if (getFailedMsg(data.recipients.device_message_status) > 0) {
      return (
        <Badge
          className="badge"
          color="secondary"
          badgeContent={getFailedMsg(data.recipients.device_message_status)}
        ></Badge>
      );
    } else if (getPendingMsg(data.recipients.device_message_status) > 0) {
      return (
        <Badge
          className="badge"
          color="secondary"
          badgeContent={getPendingMsg(data.recipients.device_message_status)}
        />
      );
    }
  }

  function getMessageTo(data) {
    let toDevices = "",
      toUsers = "";
    if (data.recipients.devices.length) {
      toDevices = data.recipients.devices
        .map((recpt, index) => {
          return Device.get(recpt)?.name;
        })
        .join(", ");
    }
    if (data.recipients.users.length) {
      toUsers = data.recipients.users
        .map((recpt, index) => {
          const getUser = User.get(recpt);
          return `${
            getUser ? getUser.first_name + " " + getUser.last_name : ""
          }`;
        })
        .join(", ");
    }
    const to =
      toDevices.length > 0 && toUsers.length > 0
        ? toDevices + ", " + toUsers
        : toDevices.length > 0
        ? toDevices
        : toUsers.length > 0
        ? toUsers
        : null;
    return to;
  }

  const useStyles = makeStyles((theme) => ({
    ...moduleMessage(theme),
  }));
  const classes = useStyles();

  return (
    <Grid container className={classes.listContainer}>
      <Grid container spacing={0} className="header" alignContent="center">
        <Grid item xs={1} className="chkBox"></Grid>
        <Grid item container xs={11}>
          <Grid item xs={3}>
            {Language.translate("TO")}
          </Grid>
          <Grid item xs={3}>
            {Language.translate("MESSAGE")}
          </Grid>
          <Grid item xs={3}>
            {Language.translate("Canned").toUpperCase()}
          </Grid>
          <Grid item xs={2}>
            <Link href="#" onClick={resetSorting} underline="none">
              <span className="dateLink">{Language.translate("DATE")}</span>
              {mwState.moduleData.sortDesc ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowDropUpIcon />
              )}
            </Link>
          </Grid>
          <Grid item xs={1}>
            {Language.translate("Status").toUpperCase()}
          </Grid>
        </Grid>
      </Grid>
      {!_.isEmpty(filteredModuleData) && mwState.moduleData.checked ? (
        filteredModuleData.map((data) => {
          //this will currently always return true but leaving the code here incase we want to check this based on recipients
          const messageViewable = !(
            Device.get(data.senders.devices) === undefined
          );
          return !(
            Device.get(data.recipients.devices) === undefined &&
            mwState.moduleData.hideUnauthorized
          ) ? (
            <Grid
              container
              spacing={0}
              className={`listItem 
              ${
                mwState.moduleData.checked.indexOf(data.id) > -1
                  ? "checked"
                  : null
              }`}
              alignItems="center"
              key={data.id}
            >
              <Grid item xs={1} className="chkBox">
                <CustomCheckbox
                  onChange={() => handleSingleCheckbox(data.id)}
                  checked={
                    mwState.moduleData.checked
                      ? mwState.moduleData.checked.indexOf(data.id) > -1
                      : false
                  }
                  name={`chk_${data.id}`}
                  value={data.id}
                />
              </Grid>
              <Grid
                item
                container
                className="rowText"
                xs={11}
                onClick={() => handleClick(data)}
              >
                <Grid className="ellipsis" item xs={3}>
                  {getMessageTo(data)}
                </Grid>
                <Grid className="ellipsis" item xs={3}>
                  {messageViewable ? data.message : null}
                </Grid>
                <Grid className="ellipsis" item xs={3}>
                  {messageViewable
                    ? Message.getCannedMessageById(data.cannedmessage_id)
                    : null}
                </Grid>
                <Grid className="ellipsis" item xs={2}>
                  {Clock.formatTimestamp(data.message_timestamp)}
                </Grid>
                <Grid item className="ellipsis status" xs={1}>
                  {_.keys(data.attachments).length > 0 ? (
                    <AttachmentIcon />
                  ) : null}
                  {showStatus(data)}
                </Grid>
              </Grid>
            </Grid>
          ) : null;
        })
      ) : (
        <Grid item xs={12} className="noMessages">
          {Language.translate("No Messages!")}
        </Grid>
      )}
    </Grid>
  );
}

export default Sent;
